import React, { FC, ReactNode } from "react";
import { message } from "antd";
import _t from "../../lang/translate";
import { isAxiosError, hasKey } from "../../utilities/typeGuard";

interface ErrorMessageProps {
  message?: ReactNode;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  return <>{message || _t("msg.unknown_error")}</>;
};

export const renderErrorMessage = (error: unknown, fallbackMessage?: string, duration?: number) => {
  if (isAntFormError(error)) {
    renderAntFormErrorMessages(error)
  } else {
    let errorMessage: string | undefined = fallbackMessage;
    if (typeof error === "string") {
      errorMessage = error;
    } else if (isAxiosError(error)) {
      const res = error.response
      if (res?.status === 413) {
        errorMessage = _t("msg.upload_files_too_large")
      } else {
        errorMessage = error.response?.data?.message;
      }
    }
    else if (error instanceof Error) {
      errorMessage = error.message;
    }
    message.error(<ErrorMessage message={errorMessage} />, duration);
  }
}

export default ErrorMessage;

const isAntFormError = (error: unknown) => {
  return typeof error === 'object'
    && !!error
    && hasKey('errorFields', error)
    && Array.isArray(error.errorFields)
    && error.errorFields.length
}
const renderAntFormErrorMessages = (error: unknown, duration = 4) => {
  // This if-check is necessary for typescript. isAntFormError(error) doesn't do type-narrowing.
  if (typeof error === 'object'
    && !!error
    && hasKey('errorFields', error)
    && Array.isArray(error.errorFields)
    && error.errorFields.length
  ) {
    let errorMessage = '';
    error.errorFields.forEach(errorField => {
      errorMessage = getErrorField_Name(errorField);
      errorMessage += ": ";
      errorMessage += getErrorField_errors(errorField);
      message.error(<ErrorMessage message={errorMessage} />, duration);
    })
  } else {
    message.error(<ErrorMessage message={null} />, duration);
  }
}

function getErrorField_Name(errorField: unknown) {
  let errorMessage = '';
  if (
    typeof errorField === 'object' &&
    errorField &&
    hasKey('name', errorField) &&
    Array.isArray(errorField.name)
  ) {
    for (const namePath of errorField.name) {
      errorMessage += String(namePath) + " ";
    }
  }
  return errorMessage
}
function getErrorField_errors(errorField: unknown) {
  let errorMessage = '';
  if (typeof errorField === 'object' && errorField &&
    hasKey('errors', errorField) &&
    Array.isArray(errorField.errors)
  ) {
    for (const errorMessages of errorField.errors) {
      errorMessage += String(errorMessages) + " ";
    }
  }
  return errorMessage
}
